import { Injectable } from '@angular/core';
import { CommonService } from 'src/app/common-service.service';

export interface BadgeItem {
  type: string;
  value: string;
}

export interface ChildrenItems {
  access_role: Number[] //  custom ('kjethi') 
  state: string;
  target?: boolean;
  name: string;
  type?: string;
  children?: ChildrenItems[];
  modal_id?: number;
}

export interface MainMenuItems {
  access_role: Number[] //  custom ('kjethi') 
  state: string;
  short_label?: string;
  main_state?: string;
  target?: boolean;
  name: string;
  type: string;
  icon: string;
  badge?: BadgeItem[];
  children?: ChildrenItems[];
  modal_id?: number;
}

export interface Menu {
  label: string;
  main: MainMenuItems[];
}

const MENUITEMS = [
  // {
  //   label: 'DASHBOARD',
  //   main: [
  //     {
  //       state: 'dashboard',
  //       short_label: 'S',
  //       name: 'Dashboard',
  //       type: 'link',
  //       icon: 'icon-layout-cta-right'
  //     },
  //   ],
  // },
  {
    label: 'ADMIN',
    main: [
      {
        access_role: [1, 2, 3],
        state: 'dashboard',
        short_label: 'D',
        name: 'Dashboard',
        type: 'link',
        icon: 'icon-layout-cta-right'
      },
      {
        access_role: [2, 3],
        state: 'designation',
        short_label: 'DE',
        name: 'Designation',
        type: 'link',
        icon: 'icon-layout-cta-right'
      },
      {
        access_role: [2],
        state: 'subusers',
        short_label: 'S',
        name: 'Sub Users',
        type: 'link',
        icon: 'icon-layout-cta-right'
      },
      
      // {
      //   access_role : [2],
      //   state: 'assignTask',
      //   short_label: 'A',
      //   name: 'Assign Task',
      //   type: 'link',
      //   icon: 'icon-layout-cta-right'
      // },
    ],
  },
  {
    label: 'REGISTRATION',
    main: [
      {
        access_role: [1],
        state: 'client',
        short_label: 'C',
        name: 'Client',
        type: 'link',
        icon: 'icon-layout-cta-right'
      },
      {
        access_role: [1],
        state: 'agent',
        short_label: 'A',
        name: 'Agent',
        type: 'link',
        icon: 'icon-layout-cta-right'
      },
      // {
      //   state: 'subscription',
      //   short_label: 'S',
      //   name: 'Subscription',
      //   type: 'link',
      //   icon: 'icon-layout-cta-right'
      // },
    ],
  },
  {
    label: 'MASTERS',
    main: [

      {
        access_role: [2, 3],
        state: 'group',
        short_label: 'G',
        name: 'Group',
        type: 'link',
        icon: 'icon-layout-cta-right'
      },

      {
        access_role: [2, 3],
        state: 'subgroup',
        short_label: 'S',
        name: 'Sub Group',
        type: 'link',
        icon: 'icon-layout-cta-right'
      },
      {
        access_role: [2, 3],
        state: 'movegroup',
        short_label: 'M',
        name: 'Move Group',
        type: 'link',
        icon: 'icon-layout-cta-right'
      },
      {
        access_role: [2, 3],
        state: 'manageData',
        short_label: 'M',
        name: 'Manage Data',
        type: 'sub',
        icon: 'icon-layout-cta-right',
        children: [
          {
            access_role: [2, 3],
            state: 'studentData',
            short_label: 'H',
            name: 'Student Data',
            type: 'link',
            icon: 'icon-layout-cta-right',
            // modal_id: 4
          },
          {
            access_role: [2, 3],
            state: 'generalData',
            short_label: 'H',
            name: 'General Data',
            type: 'link',
            icon: 'icon-layout-cta-right',
            // modal_id: 4
          }
        ]
      },
      {
        access_role: [1, 2, 3],
        state: 'template',
        short_label: 'T',
        name: 'Template',
        type: 'link',
        icon: 'icon-layout-cta-right'
      },
      // {
      //   access_role: [1, 2, 3],
      //   state: 'reports',
      //   short_label: 'T',
      //   name: 'Report',
      //   type: 'link',
      //   icon: 'icon-layout-cta-right'
      // },
      {
        access_role: [2, 3],
        state: 'subject',
        short_label: 'S',
        name: 'Subject',
        type: 'link',
        icon: 'icon-layout-cta-right'
      },
      {
        access_role: [2, 3],
        state: 'rank',
        short_label: 'K',
        name: 'Rank',
        type: 'link',
        icon: 'icon-layout-cta-right'
      },

      {
        access_role: [1, 3],
        state: 'country',
        short_label: 'C',
        name: 'Country',
        type: 'link',
        icon: 'icon-layout-cta-right'
      },
      {
        access_role: [1, 3],
        state: 'state',
        short_label: 'S',
        name: 'State',
        type: 'link',
        icon: 'icon-layout-cta-right'
      },
      {
        access_role: [1, 3],
        state: 'city',
        short_label: 'C',
        name: 'City',
        type: 'link',
        icon: 'icon-layout-cta-right'
      },

      // {
      //   state: 'department',
      //   short_label: 'D',
      //   name: 'Department',
      //   type: 'link',
      //   icon: 'icon-layout-cta-right'
      // },


    ],
  },
  {
    label: 'TRANSACTION',
    main: [
      {
        access_role: [2, 3],
        state: 'attendance',
        short_label: 'A',
        name: 'Attendance',
        type: 'link',
        icon: 'icon-layout-cta-right',
        modal_id: 5
      },
      {
        access_role: [2, 3],
        state: 'result',
        short_label: 'R',
        name: 'Result',
        type: 'link',
        icon: 'icon-layout-cta-right',
        modal_id: 3
      },
      {
        access_role: [2, 3],
        state: 'fee',
        short_label: 'F',
        name: 'Fee SMS',
        type: 'link',
        icon: 'icon-layout-cta-right',
        modal_id: 1
      },
      {
        access_role: [2, 3],
        state: 'others',
        short_label: 'O',
        name: 'Others',
        type: 'sub',
        icon: 'icon-direction-alt',
        children: [
          {
            access_role: [2, 3],
            state: 'homework',
            short_label: 'H',
            name: 'Home Work',
            type: 'link',
            icon: 'icon-layout-cta-right',
            modal_id: 4
          },
          {
            access_role: [2, 3],
            state: 'memo',
            short_label: 'M',
            name: 'Memo',
            type: 'link',
            icon: 'icon-layout-cta-right'
          },
          {
            access_role: [2, 3],
            state: 'notice',
            short_label: 'N',
            name: 'Notice',
            type: 'link',
            icon: 'icon-layout-cta-right',
            modal_id: 6
          },
          {
            access_role: [2, 3],
            state: 'circulars',
            short_label: 'C',
            name: 'Circulars',
            type: 'link',
            icon: 'icon-layout-cta-right',
            modal_id: 7
          },
          {
            access_role: [2, 3],
            state: 'invitation',
            short_label: 'I',
            name: 'Invitation',
            type: 'link',
            icon: 'icon-layout-cta-right',
            modal_id: 8
          },
          {
            access_role: [2, 3],
            state: 'announcement',
            short_label: 'I',
            name: 'Announcement',
            type: 'link',
            icon: 'icon-layout-cta-right'
          },
          {
            access_role: [2, 3],
            state: 'happenings',
            short_label: 'H',
            name: 'Happenings',
            type: 'link',
            icon: 'icon-layout-cta-right'
          },
          {
            access_role: [2, 3],
            state: 'beAlert',
            short_label: 'A',
            name: 'Be Alert',
            type: 'link',
            icon: 'icon-layout-cta-right'
          },
          {
            access_role: [2, 3],
            state: 'examWish',
            short_label: 'I',
            name: 'Exam Wish',
            type: 'link',
            icon: 'icon-layout-cta-right'
          },
        ]
      },
      {
        access_role: [2, 3],
        state: 'graph',
        short_label: 'I',
        name: 'Graph',
        type: 'link',
        icon: 'icon-layout-cta-right'
      },
      {
        access_role: [2, 3],
        state: 'promotion',
        short_label: 'O',
        name: 'Promotion',
        type: 'link',
        icon: 'icon-layout-cta-right',
        modal_id: 9

      },
    ],
  },
  {
    label: 'PayFEE',
    main: [
      // {
      //   state: 'fee',
      //   short_label: 'F',
      //   name: 'Fee',
      //   type: 'link',
      //   icon: 'icon-layout-cta-right'
      // },
      {
        access_role: [2, 3],
        state: 'fee',
        short_label: 'F',
        name: 'Fee Management',
        type: 'sub',
        icon: 'icon-direction-alt',
        children: [
          {
            access_role: [2, 3],
            state: 'feeAdd',
            name: 'Add Fee',
            // target: true
            type: 'link',
          },
          {
            access_role: [2, 3],
            state: 'feeReceived',
            name: 'Received Fee',
            // target: true
            type: 'link',
          },
          // {
          //   state: 'feeDue',
          //   name: 'Due Fee',
          //   // target: true
          //   type: 'link',
          // },
          // {
          //   state: 'ataGlance',
          //   name: 'At a Glance',
          //   // target: true
          //   type: 'link',
          // },
        ]
      },
    ],
  },
  {
    label: 'FreeBEE',
    main: [
      {
        access_role: [2, 3],
        state: 'inquiries',
        short_label: 'I',
        name: 'Inquiries',
        type: 'link',
        icon: 'icon-layout-cta-right',
        modal_id: 10
      },
      // {
      //   access_role : [2,3],
      //   state: 'inquiriesFollowup',
      //   short_label: 'I',
      //   name: 'Inquiries Followup',
      //   type: 'link',
      //   icon: 'icon-layout-cta-right',
      //   modal_id : 10
      // },
     
      {
        access_role: [2, 3],
        state: 'greetings',
        short_label: 'I',
        name: 'Greetings',
        type: 'link',
        icon: 'icon-layout-cta-right',
        modal_id: 10
      },
    ],
  },
  {
    label: 'REPORTS',
    main: [
      {
        access_role: [2, 3],
        state: 'smsDelivery',
        short_label: 'S',
        name: 'SMS Delivery',
        type: 'link',
        icon: 'icon-layout-cta-right'
      },
      {
        access_role: [2, 3],
        state: 'attendanceReport',
        short_label: 'A',
        name: 'Attendance',
        type: 'link',
        icon: 'icon-layout-cta-right',
        modal_id: 5
      },
      {
        access_role: [2, 3],
        state: 'resultReport',
        short_label: 'A',
        name: 'Result',
        type: 'link',
        icon: 'icon-layout-cta-right',
        modal_id: 3
      },
      {
        access_role: [2, 3],
        state: 'feeReport',
        short_label: 'A',
        name: 'Fee',
        type: 'link',
        icon: 'icon-layout-cta-right'
      },
    ],
  },
  {
    label: 'HELP',
    main: [
      {
        access_role: [1,2, 3],
        state: 'page',
        short_label: 'O',
        name: 'Subscription Request',
        type: 'sub',
        icon: 'icon-direction-alt',
        children: [
          // {
          //   access_role: [1, 2, 3],
          //   state: 'subscriptionRequest',
          //   short_label: 'R',
          //   name: 'Service Request',
          //   type: 'link',
          //   icon: 'icon-layout-cta-right'
          // },
          {
            access_role: [1, 2, 3],
            state: 'subscriptionRequestsms',
            short_label: 'R1',
            name: 'SMS Request',
            type: 'link',
            icon: 'icon-layout-cta-right'
          },
        ]
      },

      {
        access_role: [1, 2, 3],
        state: 'trainingRequest',
        short_label: 'T',
        name: 'Training Request',
        type: 'link',
        icon: 'icon-layout-cta-right'
      },
      {
        access_role: [2, 3],
        state: 'feedback',
        short_label: 'F',
        name: 'Feedback',
        type: 'link',
        icon: 'icon-layout-cta-right'
      },
      {
        access_role: [2, 3],
        state: 'referenceData',
        short_label: 'R',
        name: 'Reference Data',
        type: 'link',
        icon: 'icon-layout-cta-right'
      },
      {
        access_role: [1],
        state: 'aceAlertInquiry',
        short_label: 'S',
        name: 'AceAlert Inquiry',
        type: 'link',
        icon: 'icon-layout-cta-right'
      },
      {
        access_role: [1],
        state: 'referFollowup',
        short_label: 'R',
        name: 'Reference Followup',
        type: 'link',
        icon: 'icon-layout-cta-right'
      },
      {
        access_role: [1],
        state: 'news',
        short_label: 'N',
        name: 'News',
        type: 'link',
        icon: 'icon-layout-cta-right'
      },
      {
        access_role: [1],
        state: 'userActivity',
        short_label: 'UA',
        name: 'User Activity',
        type: 'link',
        icon: 'icon-layout-cta-right'
      },
    ],
  }

];

@Injectable()
export class MenuItems {
  FINAL_MENUITEMS: any = [];
  PromotionFlag;
  Role_Id;
  UserPermission;
  constructor(private commonService: CommonService) {

    if (this.commonService.getUserDataFromLocalStorage()) {
      this.Role_Id = this.commonService.getUserDataFromLocalStorage().User_Type;
      this.PromotionFlag = this.commonService.getUserDataFromLocalStorage().promotionFlag;
      this.UserPermission = JSON.parse(this.commonService.getUserDataFromLocalStorage().UserPermission);
    }

    // this.FINAL_MENUITEMS = MENUITEMS;
    if (this.UserPermission) {

      this.UserPermission = this.UserPermission.map(Number);
    } else {
      this.UserPermission = [];
    }

    MENUITEMS.forEach((res: Menu, key) => {
      let final_arr = res.main.filter((r: any) => {
        if (r.access_role.indexOf(this.Role_Id) == -1 || (r.hasOwnProperty('modal_id') && this.UserPermission.indexOf(r.modal_id) == -1)) {
          return false;
        }
        else {
          if (r.modal_id == 9) {
            if (this.PromotionFlag == 'Transaction') {
              return false;
            }
            else {
              return true;
            }
          }
          else {
            return true;
          }
        }
      });
      final_arr.forEach((res) => {
        if (res.hasOwnProperty('children')) {
          res.children = res.children.filter((r1) => {
            if (r1.access_role.indexOf(this.Role_Id) == -1 || (r1.hasOwnProperty('modal_id') && this.UserPermission.indexOf(r1.modal_id) == -1)) {
              return false;
            }
            else {
              return true;
            }
          })
        }
      })
      if (final_arr.length > 0) {
        this.FINAL_MENUITEMS.push({
          label: res.label,
          main: final_arr
        });
      }
      else {
      }
    });
  }
  getAll(): Menu[] {

    return this.FINAL_MENUITEMS;
  }

}
